import type { GameDescriptor } from '@everyturn/engine/runtime';

export const layoutTestDescriptor = {
  gameId: 'layout-test',
  displayName: 'Layout Test (9 zones)',
  seats: ['south'],
  minPlayers: 1,
  maxPlayers: 1,
  defaultSeat: 'south',
} as const satisfies GameDescriptor;
